import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class PublicApiKeyService {
  private apiKeySubject = new BehaviorSubject<string | null>(null);
  public apiKey$ = this.apiKeySubject.asObservable();
  private readonly STORAGE_KEY = 'public_api_key';
  constructor() {
    const storedKey = sessionStorage.getItem(this.STORAGE_KEY);
    if (storedKey) {
      this.apiKeySubject.next(storedKey);
    }
  }
  setApiKey(key: string): void {
    sessionStorage.setItem(this.STORAGE_KEY, key);
    this.apiKeySubject.next(key);
  }
  getApiKey(): string | null {
    return this.apiKeySubject.value;
  }
  clearApiKey(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
    this.apiKeySubject.next(null);
  }
  hasApiKey(): boolean {
    return this.apiKeySubject.value !== null;
  }
}

